import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { PurgeDataRequest } from '../Models';

@Injectable({
    providedIn: 'root'
})
export class PurgeDataService {
    private baseUrl = "/api/purge";
    constructor(private http: HttpClient) { }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    public purgeModuleRecordData(deleteRequest: PurgeDataRequest): Observable<object> {
        const options = {
            "headers": this.headers,
            "body": JSON.stringify(deleteRequest)
        }
        const url = `${this.baseUrl}/modulerecords`;
        return this.http.delete(url, options);
    }

    public purgeHierarchyData(tenantId: string): Observable<object> {
        const options = {
            "headers": this.headers,
            "body": JSON.stringify(tenantId)
        }
        const url = `${this.baseUrl}/hierarchy/`;
        return this.http.delete(url, options);
    }
}